import React from 'react';
import styled from '@emotion/styled';

import FleetbackIcon from 'assets/icons/fleetback-icon-colored.svg';

const Wrapper = styled.div`
  position: relative;
  display: block;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  margin: 0 auto;
`;

const StyledFleetbackIcon = styled(FleetbackIcon)`
  width: 78px;
  height: 68px;
  margin-bottom: 20px;
`;

/** @type {React.FC<undefined>} */
const SimplePage = ({ children }) => (
  <Wrapper>
    <div className="bubble-circle-2 bubble-circle">
      <StyledFleetbackIcon />
      <p>{children}</p>
    </div>
    <div className="bubble-circle-1 bubble-circle bubble-circle-animate" />
    <div className="bubble-circle-0 bubble-circle bubble-circle-animate" />
  </Wrapper>
  );

export default SimplePage;
